<template>
    <div class="avatar-wrap">
        <b-modal id="avatar-modal" title="Crop avatar" @ok="crop">
            <vue-croppie ref="croppieRef"
                         :enableOrientation="true"
                         :mouseWheelZoom="false"
                         :boundary="{width: 400, height: 400}"
                         :viewport="{ width: 200, height: 200, type: 'circle' }" />
        </b-modal>
        <div class="avatar-img" @click="openLoadImage">
            <input type="file" ref="file" accept=".jpg, .jpeg, .png" @change="loadImage" hidden>
            <user-avatar :user="user" />
            <div class="edit-wrap">
                <img :src="require('@/assets/images/camera.svg')" width="24" height="24" />
            </div>
        </div>
    </div>
</template>

<script>
import UserAvatar from '@/components/UserAvatar';
import auth from '@/auth'
export default {
    name: 'EditUserAvatar',
    components: {UserAvatar},
    data() {
        return {
        }
    },
    computed: {
        user() {
            return this.$store.getters['auth/currentUser']
        }
    },
    methods: {
        openLoadImage() {
            this.$refs.file.click()
        },
        async loadImage() {
            let input = this.$refs.file
            let file = input.files
            if (file && file[0]) {
                var reader = new FileReader();
                reader.onload = e => {
                    this.$refs.croppieRef.bind({
                        url: e.target.result
                    });
                };
                reader.readAsDataURL(file[0]);
                this.$bvModal.show('avatar-modal')

            }
        },
        async crop() {
            let options = {
                type: 'blob',
                format: 'jpeg',
                circle: true
            }
            this.$refs.croppieRef.result(options, async (output) => {
                this.cropped = output;
                let fd = new FormData()
                fd.append('avatar', output)
                try {
                    let resp = await auth.loadAvatar(fd)
                    await this.$store.commit('auth/UPDATE_USER_AVATAR', resp.avatar)
                    this.$nextTick(() => {
                        console.log('force upd')
                        this.$forceUpdate();
                    })
                } catch (e) {
                    console.log(e)
                }
            });
        }
    }
}
</script>

<style lang="scss">
    .avatar-wrap {
        display: flex;
        justify-content: center;
        .avatar-img {
            width: 160px;
            height: 160px;
            border-radius: 50%;
            position: relative;
            overflow: hidden;
            &:hover {
                .edit-wrap {
                    height: 100%;
                    transition: height 30ms ease-in-out;
                    img {
                        width: 30px!important;
                        height: 30px!important;
                    }
                }
            }
            .edit-wrap {
                position: absolute;
                bottom: 0;
                height: 30%;
                background: rgba(0, 0, 0, 0.3);
                //background: #fff;
                z-index: 10;
                display: flex;
                justify-content: center;
                align-items: center;
                transition: height 30ms ease-in-out;
                svg {
                    width: 24px;
                    height: 24px;
                }
            }
            &>div {
                width: 100%;
                height: 100%;
            }
            .b-avatar {
                width: 160px;
                height: 160px;
                font-size: 60px;
            }
        }
    }
</style>